import { SignOut as ExitIcon } from "@phosphor-icons/react"

export default ExitIcon
